import React, { useState, useCallback } from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { authenticateMagicLink } from '../actions/authenticationActions';
import { PasswordlessLoginForm } from '../components/login/PasswordlessLoginForm';
import background from '../assets/images/MinBuZaBackground.jpg';
import Logo from '../assets/logo.svg';
import Toast from '../components/layout/Toast';
import packageInfo from '../../package.json';

const LoginWrapper = styled('div')`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  width: 100%;
  max-width: 480px;
`;

const ContainerWrapper = styled('div')`
  min-height: 100vh;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('${background}');
`;

const MetaData = styled('div')`
  text-align: center;
  color: ${(props) => props.theme.textColors.lightgray};
  margin-top: 20px;
`;

const LogoImage = styled('img')`
  margin-bottom: 30px;
`;

const Login = ({ authenticate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = useCallback(async (email) => {
    setIsLoading(true);
    setIsError(false);
    setErrorMessage('');
    
    try {
      await authenticate({ destination: email });
      setIsSuccess(true);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      setIsSuccess(false);
      
      // Extract error message from server response
      let serverErrorMessage = '';
      if (error?.response?.data?.message) {
        serverErrorMessage = error.response.data.message;
      } else if (error?.response?.data?.code) {
        serverErrorMessage = error.response.data.code;
      } else if (error?.response?.data?.errors) {
        const firstError = Object.values(error.response.data.errors)[0];
        serverErrorMessage = firstError;
      } else if (error?.message) {
        serverErrorMessage = error.message;
      }
      
      setErrorMessage(serverErrorMessage);
    }
  }, [authenticate]);

  const handleReset = useCallback(() => {
    setIsSuccess(false);
    setIsError(false);
    setIsLoading(false);
    setErrorMessage('');
  }, []);


  return (
    <ContainerWrapper>
      <Toast />
      <LoginWrapper>
        <LogoImage src={Logo} alt="VDBS" />
        <PasswordlessLoginForm
          titleId="passwordless_login.proforma_title"
          subtitleId="passwordless_login.proforma_subtitle"
          onLogin={handleLogin}
          isLoading={isLoading}
          isSuccess={isSuccess}
          isError={isError}
          errorMessage={errorMessage}
          onReset={handleReset}
          showHowItWorksSection={true}
        />
        <MetaData>{`v${packageInfo.version}`}</MetaData>
      </LoginWrapper>
    </ContainerWrapper>
  );
};

Login.propTypes = {
  authenticate: PropTypes.func.isRequired,
  redirect: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  authenticate: (credentials) => dispatch(authenticateMagicLink(credentials))
});

export default connect(null, mapDispatchToProps)(Login);
